import CustomText from "../../atomic/CustomText";

interface AddPatientButtonProps {
  searchText: string;
  onClick: () => void;
}

function AddPatientButton({
  searchText,
  onClick,
}: Readonly<AddPatientButtonProps>): JSX.Element {
  if (!searchText) return <></>;

  return (
    <button
      className="py-4 px-4 shadow-[0_1px_3px_3px_rgba(0,0,0,0.1)] md:flex-row flex items-start md:items-center sticky bottom-0 w-full bg-white border-t"
      onClick={onClick}
      type="button"
    >
      <CustomText
        text="+ ADD"
        fontWeight="font-semibold"
        fontSize="md:text-sm text-xs"
      />
      <CustomText
        text={searchText}
        fontWeight="font-semibold"
        fontSize="md:text-sm text-xs"
        className="text-primary capitalize mx-2 truncate"
      />
      <CustomText
        text=" as a new patient"
        fontWeight="font-semibold"
        fontSize="md:text-sm text-xs"
        className="uppercase"
      />
    </button>
  );
}

export default AddPatientButton;

